{
  "#WWS_ABC_ANALYSIS": {
    "TITLE": "ABC Analysis",
    "CONFIGURATION": {
      "PLACEHOLDER": "Select ABC analysis"
    },
    "FILTER": {
      "RESET": "Reset",
      "PERIOD": "Period",
      "SALES_ORGANISATION": "Sales organisation",
      "MAIN_GROUP": "Main group",
      "SUB_GROUP": "Sub group",
      "SUPPLIER": "Supplier",
      "PRODUCT_GROUP": "Product group",
      "PRODUCT": "Article",
      "DEPARTMENT": "Department",
      "COST_CENTER": "Cost centre",
      "PROMOTION": "Promotion",
      "SLOW_MOVER_ONLY": "Slow movers only",
      "IN_STOCK_ONLY": "In stock only",
      "IN_ACTIVE_PROMOTION_ONLY": "Active promotion items only"
    },
    "DETAIL_HINT": "Select a row for article details",
    "SORT_HINT": "Click column header to sort",
    "SEARCH_PLACEHOLDER": "Search article number or description",
    "ARTICLE_COUNT_LABEL": "articles",
    "OVERVIEW_LOAD_ERROR": "Data could not be loaded",
    "SEGMENT_TOOLTIP": {
      "ARTICLE_LABEL": "Articles"
    },
    "SEGMENT_TITLE": "Segment",
    "CLASSIFIED_BY": "Classified by",
    "SCOPE_LABEL": "Scope",
    "EDIT_FILTERS_BUTTON": "Edit filters",
    "FILTERS_ACTIVE_LABEL": "filters active",
    "PAGE_LABEL": "Page",
    "COLUMNS": {
      "SEGMENT": "Segment",
      "PRODUCT_NUMBER": "Article",
      "PRODUCT_DESCRIPTION": "Description",
      "RANK": "Rank",
      "SHARE_PERCENT": "Share %",
      "CUMULATIVE_PERCENT": "Cum. %",
      "ARTICLE_COUNT": "Count",
      "ARTICLE_COUNT_PERCENT": "Count %",
      "SALES_QUANTITY": "Sales Qty.",
      "CONTRIBUTION_MARGIN": "Margin",
      "CONTRIBUTION_MARGIN_PERCENT": "Margin %",
      "NET": "Revenue",
      "NET_PERCENT": "Revenue %",
      "INVENTORY_QUANTITY": "Stock Qty.",
      "INVENTORY_VALUE": "Stock Value",
      "INVENTORY_VALUE_PERCENT": "Stock Value %"
    },
    "DETAIL_PANEL": {
      "VKORG_COLUMN": "Sales org",
      "TOTAL_LABEL": "Total",
      "LISTED_BADGE": "Listed",
      "NOT_LISTED_BADGE": "Not listed",
      "PRODUCT_NR": "Art. no.",
      "SALES_ORGANISATIONS_TITLE": "Sales organisations",
      "SALES_ORGANISATIONS_HINT": "Select a row – the figures below apply to that sales organisation.",
      "SALES_SECTION_TITLE": "Sales in period",
      "STOCK_SECTION_TITLE": "Stock",
      "PURCHASE_SECTION_TITLE": "Purchasing",
      "SALES_PRICE": "Sales price",
      "LAST_SALES_DATE": "Last sale",
      "PURCHASE_QUANTITY": "Purchase quantity",
      "LAST_PURCHASE_PRICE": "Last purchase price",
      "FIRST_PURCHASE_DATE": "First purchase",
      "LAST_PURCHASE_DATE": "Last purchase",
      "DAYS_NOT_SOLD": "Days not sold",
      "CUMULATIVE": "cumulative"
    }
  }
}
